var jQuery = require('jquery');
var console = require('console');
var Utils = require('../common/utils.js');
var codes = require('../common/codes.js');

var BasicEidCard = require('../card/basicEidCard.js');
var CardReaderMonitor = require('../card/cardReaderMonitor.js');


module.exports = MiddleWareApi;

function MiddleWareApi(config){
		
	//initial config
	var _httpBaseUrl = Utils.getDefaultProperty(config, "httpBaseUrl", "http://localhost:20201/");
	var _httpsBaseUrl = Utils.getDefaultProperty(config, "httpsBaseUrl", "https://client.localmiddleware.be:20202/");
	var baseUrl =  ( Utils.isHttps() ) ? _httpsBaseUrl : _httpBaseUrl;
	
	
	var _cardReaderMonitor = null;
	
	var _middlewareErrorCodes = {
			uuidExpired : "uuid-expired",
			wrongPin : "wrong-pin"
	};
	
	
	/*** communication with middleware ***/
	
	
	var MiddlewareCommunication = {
			
		/*** utility functions ***/	
			
		
		/**
		 * makes an ajax call to the middleware. 
		 * @returns a promise with the data on success or en error on failure
		 */
		ajax : function(url, params){
			var communicationResult = jQuery.Deferred();
			
			$.ajax(url, params ).done(function (data){
				if(data.hasOwnProperty("error")){
					
					var error = data.error;
					console.log("Received error while making call to '" + url + "' received error: " + JSON.stringify(error));
					var returnedError = {
							errorCode : codes.errorCodes.communicationError,
							message : error.message,
							internalError : error
					}
					
					//TODO: map internal errors to js API errors
					if(error.errorCode === _middlewareErrorCodes.uuidExpired){
						
					}
					communicationResult.reject(returnedError);
					
				}else{
					communicationResult.resolve(data);
				}
				
			}).fail(function (jqXHR, textStatus){
				var message = "Failed to make call to '" + url + "' received status: " + textStatus;
				console.log(message);
				/*
				if(status == "timeout" ||  ( status == "error" && jqXHR.state() == "rejected") ){
					currentStatus = codes.statusCodes.serviceNotRunning;
				}else{
					currentStatus = codes.statusCodes.internalServiceError;
				}
				*/
		
				communicationResult.reject({
					errorCode : codes.errorCodes.communicationError,
					message : message,
					internalError : null
					});
			});
			
			
			return communicationResult.promise();
		},
		
		/**
		 * get the error details as an object that has the tag names as a property and the tag value als de value of the property
		 */
		_getErrorDetails : function(error){
			var details = {};
			for( var i = 0; i < error.details.length ; i++){
				details[error.details[i].tag] = error.details[i].value;
			}
			return details;
		},
		
		
		/*** general functions ****/
		
		/**
		* Will return a promise about the service availability
		*
		*/
		serviceAvailability : function(){
			var serviceAvailabilityDeferred = jQuery.Deferred();
			MiddlewareCommunication.ajax(Utils.createUrl(baseUrl, "version"))
				.done(function(){
					serviceAvailabilityDeferred.resolve(codes.statusCodes.ok);
				}).fail(function(){
					serviceAvailabilityDeferred.resolve(codes.statusCodes.serviceNotRunning);
				});
			
			
			return serviceAvailabilityDeferred.promise()

		},
		
		/**
		 * Returns a promise that will return the version when done
		 */
		version : function(){
			return MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "version"), {
				method: "GET",
				dataType: "json",
				cache : false,
				timeout: 100
			} );
		},
		
		
		session : function(){
			return MiddlewareCommunication.ajax(Utils.createUrl(baseUrl, "session"), {
				method: "GET",
				dataType: "json",
				cache : false,
				timeout: 500
			});
		},
		
		
		/**
		 * 
		 * a promise that will return the status when done
		 */
		status : function(){
			return MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "status"), {
				method: "GET",
				dataType: "json",
				cache : false,
				timeout: 500
			} );
			
		},
		
		/**
		 * A promise that will return the events when done
		 * 
		 */
		events : function(sessionid){
			var defaultTimeout = 30000;
			return MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "events", {timeout : defaultTimeout, sessionId : sessionid}), {
				method: "GET",
				dataType: "json",
				cache : false,
				timeout: defaultTimeout + 500
			});
		},
		
		
		isEid : function(eventUuid){
			var eidUuidResult = jQuery.Deferred();
			
			MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "eID/id", {uuid : eventUuid}), {
				method: "GET",
				dataType: "json",
				cache : false,
				timeout: 500
			}).done(function(data){
					console.log("Found eID card with uuid " + data.uuid);
					eidUuidResult.resolve(data.uuid);
			}).fail(function(error){
				eidUuidResult.reject(error);
			});

			return eidUuidResult.promise();
		},
		
		
		/*** eid card functions ***/
		
		eid : {
		
			/**
			 * Helper function to read data from the card
			 */
			_readEidData : function(uuid, dataName , callback){
				MiddlewareCommunication.ajax(Utils.createUrl(baseUrl, "eID/" + dataName , {uuid: uuid}), {
					method: "GET",
					dataType: "json",
					cache : false,
					timeout: 5000
				} ).done(function(data){
					callback(data[dataName], null);
				}).fail(function(error){
					if(error.internalError){
						//TODO: check if we can interpret it
					}
					console.log("Failed to read '" + dataName + "' because: " + error.message);
					callback(null, error);
				});
			},
			
			
			
			readCitizenCertificate : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "citizenCertificate" , callback);
			},
			
			readRnData : function(uuid, callback){
				MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "eID/rnData" , {uuid: uuid}), {
					method: "GET",
					dataType: "json",
					cache : false,
					timeout: 5000
				} ).done(function(rnData){
					callback({
						name : rnData.name,
						firstName : rnData.firstName,
						altFirstName : rnData.altFirstName,
						thirdNameInitial : rnData.thirdNameInitial,
						cardNumber : rnData.cardNumber,
						dateStart : rnData.startDate,
						dateEnd : rnData.endDate,
						deliveryMunicipality : rnData.deliveryMunicipality,
						nationalNumber : rnData.nationalNumber,
						birthLocation : rnData.birthLocation,
						birthDate : rnData.birthDate,
						gender : rnData.birthDate,
						nobleCondition : rnData.nobleCondition,
						specialStatus : rnData.specialStatus,
						photoHashBase64 : rnData.photoHash,
						docType : rnData.docType,
						nationality: rnData.nationality
					}, null);
				}).fail(function(error){
					if(error.internalError){
						//TODO: check if we can interpret it
					}
					console.log("Failed to read rn data because: " + error.message);
					callback(null, error);
				});
			},
			
			readRawRnData : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "rawRnData" , callback);
			},
			
			readAddressData : function(uuid, callback){
				MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "eID/addressData" , {uuid: uuid}), {
					method: "GET",
					dataType: "json",
					cache : false,
					timeout: 5000
				} ).done(function(data){
					callback({
						streetFull : data.streetFull,
						street : data.street,
						number : data.number,
						numberExtra : data.numberExtra,
						zipCode : data.zipCode,
						municipality : data.municipality
					}, null);
				}).fail(function(error){
					if(error.internalError){
						//TODO: check if we can interpret it
					}
					console.log("Failed to read address data because: " + error.message);
					callback(null, error);
				});
			},
			
			readRawAddressData : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "rawRnData" , callback);
			},
			
			readPhoto : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "photo" , callback);
			},
			
			readRnDataSignature : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "rnDataSignature" , callback);
			},
			
			readAddressDataSignature : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "addressDataSignature" , callback);
			},
			
			readRnCertificate : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "rnCertificate", callback);
			},
			
			readRootCertificate : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "rootCertificate", callback);
			},
			
			readAuthenticationCeritifcate : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "authenticationCertificate" , callback);				
			},
			
			readNonRepudationCertificate : function(uuid, callback){
				MiddlewareCommunication.eid._readEidData(uuid, "nonRepudiationCertificate" , callback);
			},
			
			
			stopSigningSession : function(uuid){
				MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "eID/signingSession" , {uuid: uuid}), {
					method: "DELETE",
					dataType: "json",
					cache : false,
					timeout: 5000
				} ).done(function(data){
					console.log("Signing session was deleted");
				}).fail(function(error){
					console.log("Failed to stop signing session: " + JSON.stringify(error));
				});
				
			},
			
			signRsaWithPin : function(uuid, pin, dataToSign, callback){
				MiddlewareCommunication.eid._signOrAuthenticate(uuid, "signRsa", pin, dataToSign, callback);
			},
			
			authenticateRsaWithPin : function(uuid, pin, dataToSign, callback){
				MiddlewareCommunication.eid._signOrAuthenticate(uuid, "authenticateRsa", pin, dataToSign, callback);
			},
			
			 _signOrAuthenticate : function(uuid, functionName, pin, dataToSign, callback){
				 MiddlewareCommunication.ajax( Utils.createUrl(baseUrl, "eID/" + functionName , {uuid: uuid}), {
					method: "POST",
					dataType: "json",
					cache : false,
					timeout: 5000,
					data : JSON.stringify({ data: dataToSign, pin: pin})
				} ).done(function(data){
					console.log("Successfully created "+ functionName+" signature: " + data.signature);
					callback(data.signature, null);
				}).fail(function(error){
					console.log("Failed to create " +functionName +" signature " + JSON.stringify(error));
					//TODO: map the proper errorcodes
					if(error.internalError){
						var internalErrorCode = error.internalError.code;
						if(internalErrorCode === _middlewareErrorCodes.wrongPin){
							var details = MiddlewareCommunication._getErrorDetails(error.internalError);
							var triesLeft = details["error_pin_triesleft"];
							if(triesLeft == 2){
								error.errorCode = codes.errorCodes.wrongPinTwoTriesLeft;
							}else if(triesLeft == 1){
								error.errorCode = codes.errorCodes.wrongPinOneTryLeft;
							}else{
								error.errorCode = codes.errorCodes.wrongPinCardBlocked;
							}
							
						}
					}
					
					
					callback(null, error);
					
				});
			 }
			
		}
		
		
	};
	

	
	/*** eid card implementation for the middleware ***/
	
	function EidCard(uuid){
		
		BasicEidCard.call(this);
		
		var _uuid = uuid;

		
		this.readCitizenCertificate = function(callback){
			MiddlewareCommunication.eid.readCitizenCertificate(_uuid ,callback);
		}
		
		this.readRnData = function(callback){
			MiddlewareCommunication.eid.readRnData(_uuid, callback);	
		}
		
		this.readRawRnData = function(callback){
			MiddlewareCommunication.eid.readRawRnData(_uuid, callback);
		}
		
		this.readAddressData = function(callback){
			MiddlewareCommunication.eid.readAddressData(_uuid, callback);
		}
		
		this.readRawAddressData = function(callback){
			MiddlewareCommunication.eid.readRawAddressData(_uuid, callback);
		}
		
		this.readPhoto = function(callback){
			MiddlewareCommunication.eid.readPhoto(_uuid, callback);
		}
		
		this.readRnDataSignature = function(callback){
			MiddlewareCommunication.eid.readRnDataSignature(_uuid, callback);
		}
		
		this.readAddressDataSignature = function(callback){
			MiddlewareCommunication.eid.readAddressDataSignature(_uuid, callback);
		}
		
		this.readRnCertificate = function(callback){
			MiddlewareCommunication.eid.readRnCertificate(_uuid, callback);
		}
		
		this.readRootCertificate = function(callback){
			MiddlewareCommunication.eid.readRootCertificate(_uuid, callback);
		}
		
		this.readAuthenticationCeritifcate = function(callback){
			MiddlewareCommunication.eid.readAuthenticationCeritifcate(_uuid, callback);
			
		}
		
		this.readNonRepudationCertificate = function(callback){
			MiddlewareCommunication.eid.readNonRepudationCertificate(_uuid, callback);
		}
		
		
		this.stopSigningSession = function(){
			this.resetPin();
			MiddlewareCommunication.eid.stopSigningSession(_uuid);
			
		}
		
		this.signRsaWithPin = function(pin, dataToSign, callback){
			MiddlewareCommunication.eid.signRsaWithPin(_uuid, pin, dataToSign, callback);
		}
		
		this.authenticateRsaWithPin = function(pin, dataToSign, callback){
			MiddlewareCommunication.eid.authenticateRsaWithPin(_uuid, pin, dataToSign, callback);
		}

		
	}
	
	//inheritd from the basic card:
	
	EidCard.prototype = Object.create( BasicEidCard.prototype);
	EidCard.prototype.constructor = EidCard;
	
	
	/*** helper functions for the middleware ***/

	/**
	 * check if middleware is available
	 */
	function checkStatus(){
		return MiddlewareCommunication.serviceAvailability();
	}
	
	function getCardReaderMonitor(){
		if(! _cardReaderMonitor){
			_cardReaderMonitor = new CardReaderMonitor();
			//start polling for events
			//get the current status
			getCardReadersStatus();
			
			pollForEvents();
			
		}
		return _cardReaderMonitor.getPublicApi();
		
	}
	
	function getCardReadersStatus(){
		MiddlewareCommunication.status().done(function(readers){
			//simulate poll events
			for(var i = 0; i < readers.length ; i++){
				var reader = readers[i];

				handlePollEvent({
					type : "reader-connected",
					readerName : reader.readerName
				});
				
				if(reader.hasOwnProperty("cardUuid")){
					handlePollEvent({
						type : "card-inserted",
						readerName : reader.readerName,
						uuid : reader.cardUuid
					});
				}
			}
			
		}).fail(function(error){
			console.log("Failed fetch readers " + JSON.stringify(error));
		});
		
	}
	
	
	function handlePollEvent(event){
		if(event.type == "reader-connected"){
			//pass a readerdescription
			_cardReaderMonitor.cardReaderConnected({
				name : event.readerName,
				//middleware only handles pcsc readers for now
				type : CardReaderMonitor.readerTypes.pcscReader
				
			});
		}else if(event.type == "reader-disconnected"){
			_cardReaderMonitor.cardReaderDisconnected(event.readerName);
		}else if(event.type == "card-removed"){
			_cardReaderMonitor.cardRemoved(event.readerName);
		}else if(event.type == "card-inserted"){
			jQuery.when( MiddlewareCommunication.isEid(event.uuid)).done(function(eidUuid){
				_cardReaderMonitor.correctCardInserted(event.readerName, new EidCard(eidUuid));
			}).fail(function(error){
				//TODO: interpret error
				if( ! error.internalError){
					_cardReaderMonitor.incorrectCardInserted();
				}else{
					console.log("Failed to check if an eid card was inserted : " + JSON.stringify(error));
				}
			});
		}
	}
	
	
	function pollForEvents(sessionid){
		//make sure we've got a session id
		if(sessionid == null){

			MiddlewareCommunication.session().done(function(session){
				pollForEvents(session.sessionId);
			}).fail(function(error){
				console.log("Failed to get a session from the middleware " + JSON.stringify(error));
				//try again with in 5 minutes
				setTimeout(function(){pollForEvents()}, 5000 );
			});
		}else{
			var defaultTimeout = 30000; // 30 sec
			var eventsStart = new Date();
			jQuery.when( MiddlewareCommunication.events(sessionid) ).done(function(events){
				//poll again on next runloop
				setTimeout(function(){pollForEvents(sessionid)}, 0);
				for(var i = 0; i < events.length; i++){
					handlePollEvent(events[i].event);
				}
			}).fail(function(error){
				var eventsEnd = new Date();
				var delayMs = eventsEnd.getTime() - eventsStart.getTime();
				//check if took more than 4 seconds
				if(delayMs > 4000){
					pollForEvents(sessionid);
				}else{	
					//schedule it after 4 sec, events stay in queue for 5 seconds
					console.log("Failed to fetch events from middleware");
					setTimeout(function(){pollForEvents(sessionid)}, 4000 - delayMs);
				}
			});
		}
		
		
	}
	
	
	return {
		checkStatus : checkStatus,
		getCardReaderMonitor : getCardReaderMonitor,
		statusCodes : codes.statusCodes
	};

}